import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_INVOICES_MEMBER_API,
	GET_INVOICES_OPTIONS_API,
	GET_INVOICES_TAX_COMPANY_API,
	GET_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_OVERVIEW_OPTIONS_API,
	POST_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_OVERVIEW_API,
	POST_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_RETURN_UPLOAD_API,
	GET_ORDER_RETURN_DOC_TRIPLICATE_UNIFORM_CONFIRM_API,
} from "@apis/apiPath";

const useInvoiceApi = () => {
	const Ajax = useAjax();

	const getInvoiceOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_INVOICES_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	const getInvoiceTaxCompanyApi = useCallback(
		async taxID => {
			const resp = await Ajax.get(GET_INVOICES_TAX_COMPANY_API, { taxID });
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	const getMemberInvoiceApi = useCallback(
		async params => {
			const { memberID } = params || {};
			return await Ajax.get(GET_INVOICES_MEMBER_API(memberID), params);
		},
		// eslint-disable-next-line
		[],
	);

	// 三聯式發票折讓總覽（invoice-allowance / triplicate-uniform）
	const getInvoiceAllowanceTriplicateUniformOverviewOptionsApi = useCallback(
		async () => {
			const resp = await Ajax.get(GET_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_OVERVIEW_OPTIONS_API);
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	const postInvoiceAllowanceTriplicateUniformOverviewApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_OVERVIEW_API, params);
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	/**
	 * 上傳三聯折讓證明單（僅圖檔）
	 * 後端：POST …/triplicate-uniform/{orderID}/returns/{orderReturnID}/upload，以 ImageHelper.IsPhotoExtension 檢查（.jpg/.jpeg/.png/.gif/.bmp），不接受 PDF
	 * FormData 欄位名為 file（IFormFile）；成功後回傳確認路徑等（TriplicateUniformConfirmResponseModel）
	 */
	const postInvoiceAllowanceTriplicateUniformReturnUploadApi = useCallback(
		async (orderID, orderReturnID, file) => {
			const formData = new FormData();
			formData.append("file", file);
			const resp = await Ajax.post(POST_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_RETURN_UPLOAD_API(orderID, orderReturnID), formData, {
				headerOption: { headers: { "Content-Type": "multipart/form-data" } },
			});
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	/**
	 * 下載已上傳之三聯折讓證明書（觸發瀏覽器下載）
	 * 路由為站台根路徑 /orders/...（非 /api/...），回應為檔案串流
	 * 依賴 useAjax.getPDF（預期 Content-Type: application/pdf）；若後端改為其他型別需改實作
	 * TODO：請與後端確認 extension、Content-Type 與是否需改為僅回傳 URL 或 blob 給預覽
	 */
	const getOrderReturnDocTriplicateUniformConfirmPdfApi = useCallback(
		async (orderID, orderReturnID, extension = "pdf") => {
			const url = GET_ORDER_RETURN_DOC_TRIPLICATE_UNIFORM_CONFIRM_API(orderID, orderReturnID, extension);
			const resp = await Ajax.getPDF(url, {}, { fileName: "triplicate-uniform-confirm" });
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	return {
		getInvoiceOptionsApi,
		getInvoiceTaxCompanyApi,
		getMemberInvoiceApi,
		getInvoiceAllowanceTriplicateUniformOverviewOptionsApi,
		postInvoiceAllowanceTriplicateUniformOverviewApi,
		postInvoiceAllowanceTriplicateUniformReturnUploadApi,
		getOrderReturnDocTriplicateUniformConfirmPdfApi,
	};
};

export default useInvoiceApi;
